import { render, staticRenderFns } from "./shareShiyanshi.vue?vue&type=template&id=32e83042&scoped=true"
import script from "./shareShiyanshi.vue?vue&type=script&lang=js"
export * from "./shareShiyanshi.vue?vue&type=script&lang=js"
import style0 from "./shareShiyanshi.vue?vue&type=style&index=0&id=32e83042&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e83042",
  null
  
)

export default component.exports